/**
 * Created by JackCui on 2022/1/17
 */

/**
 * 隐藏字段或者不是当前对象字段 则调用接口查询值 (暂无使用)
 * @param data
 * @returns {{}}
 */
// TODO 查询全部隐藏字段的值 接口请求待联调
export const expressValue = (data) => {
  const arr = {}
  data.forEach(v => {
  })
  return arr
}

/**
 * 处理规则变量的集合
 * @param varRules 规则中的全部变量
 * @param varField 当前页面中字段全部变量
 * @returns {[]}
 */
export const varDataHandle = (varRules, varField) => {
  const keys = []

  for (let k in varRules) {
    if (!varRules.hasOwnProperty(k)) {
      continue
    }
    if (!varField.hasOwnProperty(k)) {
      keys.push(varRules[k])
    }
  }

  return keys
}

/**
 * 拼装objectApiName和fieldApiName
 * @param data
 * @returns {{}}
 */
export const apiNameJoin = (data) => {
  const newData = {}
  for (let k in data) {
    if (!data.hasOwnProperty(k)) {
      continue
    }
    const item = data[k]
    for (let v in item) {
      if (!item.hasOwnProperty(v)) {
        continue
      }
      newData[`${k}_${v}`] = item[v]
    }
  }
  return newData
}

/**
 * 储存是否满足条件的两个数组 包括向数组中推送元素的封装
 * @returns {object}
 */
export const sortEventHandle = () => {
  // 规则中的事件列表 (前端抽象出来的 方便排序)
  // 实际为eventType, elementType两个字段区分出来的
  const sortEventType = ['rule_required_2', 'rule_show_2', 'rule_readonly_2', 'rule_textShow_2', 'rule_show_5']
  const eventsMap = {
    validEvent: [[], []],
    pushItem (bool, ...item) {
      const events = eventsMap.validEvent[Number(bool)]
      const join = ({eventType, elementType}) => `rule_${eventType}_${elementType}`

      events.push(...item)
      // 排序需要操作的字段
      // 分别把触发和不触发的字段排序 以sortEventType的优先级排序
      events.sort(
        (a, b) =>
          sortEventType.indexOf(join(a)) - sortEventType.indexOf(join(b))
      )
    }
  }

  return eventsMap
}
